module.exports = __webpack_public_path__ + "static/media/bord.81e76617.png";